import { baseURL } from '@/services/api';
import { getToken } from '@/services/auth';
import { getReportFileName } from './getReportFileName';

// Mesmo padrão de download de relatórios .xlsx já usado em StudyHours, UptimeMonthly,
// Performance, PlatformUsage, LiveTransmissions e Intervention: fetch autenticado +
// parse do filename via Content-Disposition + download via link temporário.
export async function downloadReportFile(path, params = {}) {
  const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')).toString();

  const response = await fetch(`${baseURL()}${path}${query ? `?${query}` : ''}`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  });

  if (!response.ok) {
    throw new Error('Erro ao baixar o relatório');
  }

  const fileName = getReportFileName(response.headers.get('content-disposition'));
  const blob = await response.blob();

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
